import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
import { EpbtFaBistrackbranchesListComponent } from '../../list/epbt-fa-bistrackbranches-list/epbt-fa-bistrackbranches-list.component';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { Location } from '@angular/common';
import { BinLocations } from 'ep-bt-field-agent-proxy';
import { IEpTextAreaModel } from '@epicor/kinetic';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-binlocation',
  templateUrl: './epbt-fa-product-binlocation.component.html',
  styleUrls: ['./epbt-fa-product-binlocation.component.scss']
})
export class EpbtFaProductBinlocationComponent implements OnInit {

  selectedBranchId: number;
  public binLocationForm: FormGroup;
  submitted = false;

  @ViewChild(EpbtFaBistrackbranchesListComponent, { static: false }) bistrackbranchesListComponent: EpbtFaBistrackbranchesListComponent;

  binsTextBoxModel: IEpTextAreaModel = {
    id: 'binsTextBoxModel',
    autoFocus: true
  };

  constructor(private formBuilder: FormBuilder,
    private binLocationService: EpbtFaProductBinlocationService,
    private fieldAgentService: EpbtFieldAgentService,
    private location: Location) { }

  ngOnInit() {
    if (this.binLocationService.selectedBranchId) {
      this.selectedBranchId = this.binLocationService.selectedBranchId;
    } else {
      try {
        this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
          if (webTrackUser && webTrackUser.bisTrackBranch && webTrackUser.bisTrackBranch.branchID > 0) {
            this.binLocationService.selectedBinLocation = new BinLocations();
            this.binLocationService.selectedBranchId = webTrackUser.bisTrackBranch.branchID;
            this.binLocationService.selectedBranch = webTrackUser.bisTrackBranch;
            this.selectedBranchId = this.binLocationService.selectedBranchId;
          } else {
            this.binLocationService.selectedBranchId = -1;
            this.selectedBranchId = this.binLocationService.selectedBranchId;
          }
        });
      } catch (ex) {
        this.location.back();
      }
    }

    this.binLocationForm = this.formBuilder.group({
      bins: ['', [Validators.required, Validators.maxLength(255)]],
    });

    this.patchValues();

    this.binLocationService.binLocationFormFlag = this.binLocationForm.valid;

    this.binLocationForm.valueChanges.subscribe(
      result => {
        this.validate();
      }
    );
  }

  patchValues() {
    if (this.binLocationService.selectedBinLocation) {
      this.binLocationForm.patchValue({
        bins: this.binLocationService.selectedBinLocation.bins.join('\n')
      });
    }
  }

  onValueChange(selectedValue: any): void {
    if (selectedValue) {
      this.selectedBranchId = selectedValue.branchID;
      this.binLocationService.selectedBranchId = selectedValue.branchID;
      this.binLocationService.selectedBranch = selectedValue;
      this.binLocationService.selectedProducts = [];
      this.binLocationService.selectedProductsForBinding = [];
      this.validate();
    }
  }

  validate() {
    if (this.binLocationForm.valid && this.selectedBranchId > 0) {
      this.binLocationService.binLocationFormFlag = this.binLocationForm.valid;
    } else {
      this.binLocationService.binLocationFormFlag = false;
    }
  }

  // This will be use in html code for validation
  get frmFields() { return this.binLocationForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.binLocationForm.valid && this.selectedBranchId > 0) {
      this.binLocationService.binLocationFormFlag = true;
      // this.binLocationService.nonfiltredBins = this.binLocationForm.controls["bins"].value.split("\n");
      const splitResult = this.binLocationForm.controls['bins'].value.replace(/[,]/g, '').split('\n').filter(Boolean);
      const trimmedResult = Array.from(new Set(splitResult.map((item: any) => item.trim())));
      const finalBins = Array.from(new Set(trimmedResult.map((item: any) => item)));
      this.binLocationService.selectedBinLocation.bins = finalBins;
      this.binLocationService.selectedBranch = this.bistrackbranchesListComponent.bisTrackBranches.filter(x => x.branchID == this.selectedBranchId)[0];
    } else {
      this.binLocationService.binLocationFormFlag = false;
    }
  }
}
